import { RECOMMENDED_SOL_BALANCE } from 'solana-bc/sol-fee'
import type { WalletBalance } from '../types'

/** How full the SOL "fuel tank" is against the recommended balance. */
export type FuelState = 'full' | 'low' | 'empty'

export interface FundingState {
  sol: number
  usdt: number
  fuel: FuelState
  /** Enough SOL for the network fees of many bets. */
  hasFuel: boolean
  /** Some USDT to play with. */
  hasStake: boolean
  isReady: boolean
  /** 0…1: the SOL share counts partly, so the bar moves with every top-up. */
  progress: number
}

const getFuelState = (sol: number): FuelState => {
  if (sol >= RECOMMENDED_SOL_BALANCE) return 'full'
  return sol > 0 ? 'low' : 'empty'
}

/** What a wallet still needs before the user can play from it. */
export const getFundingState = (balance?: WalletBalance): FundingState => {
  const sol = balance?.nativeBalance ?? 0
  const usdt = balance ? balance.tokenBalance + balance.tokenDeposited : 0
  const hasFuel = sol >= RECOMMENDED_SOL_BALANCE
  const hasStake = usdt > 0
  const solShare = Math.min(1, sol / RECOMMENDED_SOL_BALANCE)

  return {
    sol,
    usdt,
    fuel: getFuelState(sol),
    hasFuel,
    hasStake,
    isReady: hasFuel && hasStake,
    progress: (solShare + (hasStake ? 1 : 0)) / 2
  }
}
